export const defaultPaymasterAndData = async (struct, { account, overrides }) => {
    const entryPoint = account.getEntryPoint();
    if (entryPoint.version === "0.6.0") {
        struct.paymasterAndData =
            overrides?.paymasterAndData ?? "0x";
    }
    else {
        delete struct
            .paymasterVerificationGasLimit;
    }
    return struct;
};
//# sourceMappingURL=paymasterAndData.js.map